import { i18n } from '@/plugins/i18n'
import  { AllShopTypes } from "@/constants/AllShopTypes"
import  { AllShopTypesStr } from "@/constants/AllShopTypes"

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('reports.gateways.gateway_title'),
        sortable: true,
        width: 120,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
        template: (row) => {
            let url = '';

            switch(row.shop_type) {
                case 1:
                    url = 'gateways';
                    break;
                case 2:
                    url = 'payman';
                    break;
                case 3:
                    url = 'ivr';
                    break;
                case 4:
                    url = 'dedicated';
                    break;
                // case 5:
                //     url = 'collective/gateway';
                //     break;
                default:
                    return row.title;
            }

            return '<a href="/' + url + '/' + row.id + '/details">'+row.title+'</a>';
        },
    },
    {
        field: 'shop_type',
        title: i18n.t('reports.gateways.shop_type'),
        sortable: false,
        width: 70,
        textAlign: 'center',
        template: (row) => {
            let shop_type  = AllShopTypesStr.get(row.shop_type)

            return '<div>'+ shop_type+'</div>'
        },
    },
    {
        field: 'total_transactions',
        title: i18n.t('reports.gateways.total_transactions'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'total_wage',
        title: i18n.t('reports.gateways.total_wage'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'unsettled_balance',
        title: i18n.t('reports.gateways.unsettled_balance'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'settled_amount',
        title: i18n.t('reports.gateways.settled_balance'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'succeed_transactions_number',
        sortable: true,
        title: i18n.t('reports.gateways.succeed_transactions_number'),
        textAlign: 'center',
        width: 70
    },
    {
        field: 'conflict_accounting',
        sortable: true,
        title:i18n.t('reports.gateways.conflict_accounting'),
        textAlign: 'center',
        // template: (row) => {
        //     let variant   = row.has_limit ? 'badge-danger' : 'badge-success'
        //     let has_limit = row.has_limit ? i18n.t('limit.limited') : i18n.t('limit.unlimited')
        //
        //     return '<div class="badge '+variant+' text-white">'+ has_limit+'</div>'
        // },
        width: 80
    },
]